import { z } from 'zod';
import { apiUrl } from '../config/api';
import type { WBS } from '../data/databaseSchema';
import { apiClient } from '../lib/apiClient';
import { apiResponseSchema, wbsSchema } from '../lib/schemas';

// Task administration moved to another application; only reads remain.
export const wbsService = {
  getWbs: async (): Promise<WBS[]> => {
    const result = await apiClient.get(apiUrl.wbs(), {
      validate: apiResponseSchema(z.array(wbsSchema)),
      deduplicate: true,
      context: 'getWbs',
    });
    return result.data;
  },
};
